import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockLocations } from '@/renderer/services/inventoryStockLocationService';
import type { InventoryStockLocationFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockLocations(
  params: InventoryStockLocationFilterParams,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockLocationsList(params),
    queryFn: async () => {
      const result = await fetchInventoryStockLocations(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock locations',
        );
      }

      return result.data;
    },
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}
